import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';

const TableCellHeaderSum = withStyles(() => ({
  head: {
    color: 'white',
    background: '#5ac4c4',
  },
  body: {
    fontSize: 14,
    fontWeight: 'bold',
  },
}))(TableCell);

export default TableCellHeaderSum;
